import { useEffect } from "react";
import { useApp } from "./useApp";

export const usePersistentState = () => {
  const { state, dispatch } = useApp();

  // Hook para persistir solo ciertos datos
  const persistData = (key, data) => {
    try {
      localStorage.setItem(`tattersall-${key}`, JSON.stringify(data));
    } catch (error) {
      console.warn(`Error saving ${key} to localStorage:`, error);
    }
  };

  // Hook para recuperar datos específicos
  const retrieveData = (key, defaultValue = null) => {
    try {
      const item = localStorage.getItem(`tattersall-${key}`);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.warn(`Error retrieving ${key} from localStorage:`, error);
      return defaultValue;
    }
  };

  // Funciones específicas para cada tipo de dato
  const persistRequests = () => {
    persistData("requests", state.requests);
  };

  const persistFilters = () => {
    persistData("filters", state.filters);
  };

  const loadPersistedRequests = () => {
    const requests = retrieveData("requests", []);
    if (requests.length > 0 && state.requests.length === 0) {
      dispatch({ type: "SET_REQUESTS", payload: requests });
    }
  };

  const loadPersistedFilters = () => {
    const filters = retrieveData("filters", {});
    if (Object.keys(filters).length > 0) {
      dispatch({ type: "SET_FILTERS", payload: filters });
    }
  };

  const clearAllPersistedData = () => {
    localStorage.removeItem("tattersall-requests");
    localStorage.removeItem("tattersall-filters");
    localStorage.removeItem("tattersall-app-state");
    dispatch({ type: "CLEAR_STORAGE" });
  };

  return {
    persistData,
    retrieveData,
    persistRequests,
    persistFilters,
    loadPersistedRequests,
    loadPersistedFilters,
    clearAllPersistedData,
  };
};
